<template>
  <component :is="layout"></component>
</template>
<script>
import HomeLayout from "@/layouts/HomeLayout.vue";
export default {
  components: {
    HomeLayout,
  },
  computed: {
    layout() {
      const layout = this.$route.meta.layout || HomeLayout;
      return () => import(`@/layouts/${layout}.vue`);
    },
  },
};
</script>

<style></style>
